import getPSTTimestamp from "../utils";
import Image from "react-bootstrap/Image";
import { parseISO, format } from "date-fns";


// export const imagePath = 'https://prod-cdn.swmc.com/swmc-common/images/wholesale-websites'
export const imagePathS3 = 'https://prod-cdn.swmc.com/swmc-common/images/wholesale-websites'
export const imagePath = 'https://d2w24n4g34usfg.cloudfront.net/wholesale-websites'
export const imagePath1 = process.env.REACT_APP_CDN+"wholesale-websites";


export const foreignNationalProgramName = 'Foreign National'
export const fha203kProgramName = 'FHA 203K'

function getDayName(day) {
    const arrayOfWeekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    return arrayOfWeekdays[day];
}

export const businessDayDescriptionDisplay = (hours_data) => {
    const turn_time_hours = hours_data;
    let businessDayDescription = "";
    if (turn_time_hours === 0) {
        businessDayDescription = (
          <div className="underWritten-on-demand-container">
            <img
              alt="Thoroughly Reviewed & Underwritten On Demand" 
              className="underWritten-on-demand"
              src={`${process.env.REACT_APP_SWMC_IMG_CDN}HomeImages/underwriting-review-time.webp`}
            />{' '}
          </div>
        );
    } else {
        // check dates multiple  of 24
        const hours_multiple_timesOf24 = turn_time_hours / 24;
        const dateTime = getPSTTimestamp(new Date());

        const dayNumber = dateTime.getDay();

        //Sunday ||   //Saturday    //Friday
        if (dayNumber === 0 || dayNumber === 6 || dayNumber === 5) {
            businessDayDescription = <span>
                <Image 
                    className="eight-hour-icon" 
                    src={`${imagePath}/eight_am_approval.svg`} 
                    width="146"
                    height="150"
                    alt=""
                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                    sizes="(max-width:1650px) 100vw, 1650px"
                    style={{width:'auto'}}
                />{' '}Monday
            </span>
        } else {
            // Monday //Thursday
            let currentHrs = dateTime.getHours();

            if (
                currentHrs === 6 ||
                currentHrs === 20 ||
                (currentHrs > 6 && currentHrs < 20)
            ) {
                // in  business hr  //(6AM-8PM) means (06:00:00 - 20:00:00)

                if (turn_time_hours < 24) {
                    businessDayDescription = "By 8 PM today";
                } else {
                    let dateTime2 = getPSTTimestamp(new Date());
                    let newDateWithMultipleOf24 = dateTime2.setDate(
                        dateTime2.getDate() + parseInt(hours_multiple_timesOf24)
                    );
                    let latestDate = new Date(newDateWithMultipleOf24);

                    let whichDay = latestDate.getDay();
                    //Sunday ||   //Saturday    //Friday
                    if (whichDay === 0 || whichDay === 6 || whichDay === 5) {
                        businessDayDescription = <span>
                            <Image 
                                className="eight-hour-icon" 
                                src={`${imagePath}/eight_am_approval.svg`} 
                                width="146"
                                height="150"
                                alt=""
                                srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                sizes="(max-width:1650px) 100vw, 1650px"
                                style={{width:'auto'}}
                            />{' '}Monday
                        </span>
                    } else {
                        if (hours_multiple_timesOf24 === 1) {
                            // businessDayDescription = "By 8 AM Tomorrow";
                            businessDayDescription = <span>
                                <Image 
                                    className="eight-hour-icon" 
                                    src={`${imagePath}/eight_am_approval.svg`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}}
                    />{' '}Tomorrow
                            </span>
                        } else {
                            businessDayDescription = <span>
                                <Image className="eight-hour-icon" 
                                    src={`${imagePath}/eight_am_approval.svg`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}{getDayName(whichDay)}
                            </span>
                        }
                    }
                }
            } else {
                // after business hr (after 8PM) => (8PM -6AM) like 8 PM (means 20:00:00) to 6AM (means 06:00:00) morning
                // we needs to add one more day directly as per logic recommended for after business hours
                if (turn_time_hours < 24) {
                    let dateTime2 = getPSTTimestamp(new Date());

                    let newDateWithTomarrow = dateTime2.setDate(dateTime2.getDate() + 1);
                    let latestDate = new Date(newDateWithTomarrow);

                    let whichDay = latestDate.getDay();
                    //Sunday ||   //Saturday    //Friday
                    if (whichDay === 0 || whichDay === 6 || whichDay === 5) {
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${imagePath}/eight_am_approval.svg`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}Monday
                        </span>
                    } else {
                        // businessDayDescription = "By 8 AM Tomorrow";
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${imagePath}/eight_am_approval.svg`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} 
                                /> Tomorrow
                        </span>

                    }
                } else {
                    let dateTime2 = getPSTTimestamp(new Date());

                    let newDateWithMultipleOf24 = dateTime2.setDate(
                        dateTime2.getDate() + parseInt(hours_multiple_timesOf24) + 1
                    );
                    let latestDate = new Date(newDateWithMultipleOf24);

                    let whichDay = latestDate.getDay();
                    //Sunday ||   //Saturday    //Friday
                    if (whichDay === 0 || whichDay === 6 || whichDay === 5) {
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${imagePath}/eight_am_approval.svg`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}Monday
                        </span>
                    } else {
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${imagePath}/eight_am_approval.svg`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${imagePath}/eight_am_approval.svg 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}{getDayName(whichDay)}
                        </span>
                    }
                }
            }
        }
    }
    return businessDayDescription;
}

export const isChenoa = process.env.REACT_APP_URL === 'chenoaprogram'
export const isUsda = process.env.REACT_APP_URL === 'usdaloans'
export const isNonQm = process.env.REACT_APP_URL === 'non-qmloans'
export const isDscrEnv = process.env.REACT_APP_URL === 'dscrloans'

/** WHL-86: made for Chenoa */
export const businessDayDescDisplay = (hours_data) => {
    const turn_time_hours = hours_data;
    let businessDayDescription = "";
    if (turn_time_hours === 0) {
        businessDayDescription = (
          <div>
            <img
              alt="Thoroughly Reviewed & Underwritten On Demand" 
              className="underWritten-on-demand"
              src={`${process.env.REACT_APP_SWMC_IMG_CDN}HomeImages/underwriting-review-time.webp`}
            />{' '}
          </div>
        );
    } else {
        // check dates multiple  of 24
        const hours_multiple_timesOf24 = turn_time_hours / 24;
        const dateTime = getPSTTimestamp(new Date());

        const dayNumber = dateTime.getDay();

        const eightHrImg = `${imagePath}/chenoa/8AmTurnTimes.svg`

        //Sunday ||   //Saturday    //Friday
        if (dayNumber === 0 || dayNumber === 6 || dayNumber === 5) {
            businessDayDescription = <span>
                <Image 
                    className="eight-hour-icon" 
                    src={`${eightHrImg}`} 
                    width="146"
                    height="150"
                    alt=""
                    srcSet={`${eightHrImg} 1650w, ${eightHrImg} 300w, ${eightHrImg} 768w,`}
                    sizes="(max-width:1650px) 100vw, 1650px"
                    style={{width:'auto'}}
                />{' '}Monday
            </span>
        } else {
            // Monday //Thursday
            let currentHrs = dateTime.getHours();

            if (
                currentHrs === 6 ||
                currentHrs === 20 ||
                (currentHrs > 6 && currentHrs < 20)
            ) {
                // in  business hr  //(6AM-8PM) means (06:00:00 - 20:00:00)

                if (turn_time_hours < 24) {
                    businessDayDescription = "By 8 PM today";
                } else {
                    let dateTime2 = getPSTTimestamp(new Date());
                    let newDateWithMultipleOf24 = dateTime2.setDate(
                        dateTime2.getDate() + parseInt(hours_multiple_timesOf24)
                    );
                    let latestDate = new Date(newDateWithMultipleOf24);

                    let whichDay = latestDate.getDay();
                    //Sunday ||   //Saturday    //Friday
                    if (whichDay === 0 || whichDay === 6 || whichDay === 5) {
                        businessDayDescription = <span>
                            <Image 
                                className="eight-hour-icon" 
                                src={`${eightHrImg}`} 
                                width="146"
                                height="150"
                                alt=""
                                srcSet={`${eightHrImg} 1650w, ${eightHrImg} 300w, ${eightHrImg} 768w,`}
                                sizes="(max-width:1650px) 100vw, 1650px"
                                style={{width:'auto'}}
                            />{' '}Monday
                        </span>
                    } else {
                        if (hours_multiple_timesOf24 === 1) {
                            // businessDayDescription = "By 8 AM Tomorrow";
                            businessDayDescription = <span>
                                <Image 
                                    className="eight-hour-icon" 
                                    src={`${eightHrImg}`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${eightHrImg} 1650w, ${eightHrImg} 300w, ${eightHrImg} 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}}
                    />{' '}Tomorrow
                            </span>
                        } else {
                            businessDayDescription = <span>
                                <Image className="eight-hour-icon" 
                                    src={`${eightHrImg}`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${eightHrImg} 1650w, ${eightHrImg} 300w, ${eightHrImg} 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}{getDayName(whichDay)}
                            </span>
                        }
                    }
                }
            } else {
                // after business hr (after 8PM) => (8PM -6AM) like 8 PM (means 20:00:00) to 6AM (means 06:00:00) morning
                // we needs to add one more day directly as per logic recommended for after business hours
                if (turn_time_hours < 24) {
                    let dateTime2 = getPSTTimestamp(new Date());

                    let newDateWithTomarrow = dateTime2.setDate(dateTime2.getDate() + 1);
                    let latestDate = new Date(newDateWithTomarrow);

                    let whichDay = latestDate.getDay();
                    //Sunday ||   //Saturday    //Friday
                    if (whichDay === 0 || whichDay === 6 || whichDay === 5) {
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${eightHrImg}`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${eightHrImg} 1650w, ${eightHrImg} 300w, ${eightHrImg} 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}Monday
                        </span>
                    } else {
                        // businessDayDescription = "By 8 AM Tomorrow";
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${eightHrImg}`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${eightHrImg} 1650w, ${eightHrImg} 300w, ${eightHrImg} 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} 
                                /> Tomorrow
                        </span>

                    }
                } else {
                    let dateTime2 = getPSTTimestamp(new Date());

                    let newDateWithMultipleOf24 = dateTime2.setDate(
                        dateTime2.getDate() + parseInt(hours_multiple_timesOf24) + 1
                    );
                    let latestDate = new Date(newDateWithMultipleOf24);

                    let whichDay = latestDate.getDay();
                    //Sunday ||   //Saturday    //Friday
                    if (whichDay === 0 || whichDay === 6 || whichDay === 5) {
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${eightHrImg}`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${eightHrImg} 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}Monday
                        </span>
                    } else {
                        businessDayDescription = <span>
                            <Image className="eight-hour-icon" 
                                    src={`${eightHrImg}`} 
                                    width="146"
                                    height="150"
                                    alt=""
                                    srcSet={`${eightHrImg} 1650w, ${imagePath}/eight_am_approval.svg 300w, ${imagePath}/eight_am_approval.svg 768w,`}
                                    sizes="(max-width:1650px) 100vw, 1650px"
                                    style={{width:'auto'}} />{' '}{getDayName(whichDay)}
                        </span>
                    }
                }
            }
        }
    }
    
    return businessDayDescription;
}

export const getInterestRatesDateTextToShow = (createdAt) => {
    let interestRatesDateText = "";
    if (createdAt) {
        const createdAtDate = createdAt;
        const formatDate = format(parseISO(createdAtDate), "MM/dd/yyyy");
        const formatTimeDisplay = format(parseISO(createdAtDate), "hh:mm a");

        // Create date from input value
        const inputDate = new Date(formatDate);

        // Get today's date
        const todaysDate = new Date();

        // checking yesterday's date
        let yesterday = new Date(todaysDate);

        const yesterdaysDate = new Date(
            yesterday.setDate(yesterday.getDate() - 1)
        );

        // call setHours to take the time out of the comparison
        if (inputDate.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0)) {
            // Date equals today's date
            interestRatesDateText = `Interest Rates as of ${formatTimeDisplay.toLowerCase()} PST Today`;
        } else if (
            inputDate.setHours(0, 0, 0, 0) === yesterdaysDate.setHours(0, 0, 0, 0)
        ) {
            // Date equals yesterday's date
            interestRatesDateText = `Interest Rates as of ${formatTimeDisplay.toLowerCase()} PST Yesterday`;
        } else {
            interestRatesDateText = `Interest Rates as of ${formatTimeDisplay.toLowerCase()} PST ${formatDate}`;
        }
    } else {
        // Date is undefined (not available )
        interestRatesDateText = `Interest Rates as of`;
        interestRatesDateText = ``; //WHL-42: try, since seems correct
    }
    return interestRatesDateText;
    // setShowInterestRatesDateText(interestRatesDateText);
}

export const descriptionToDisplay = (turnTimeProductData) => {
    const turnTimeProductDataDetails = turnTimeProductData;
    let turn_time_description_ToShow = "";
    if (turnTimeProductDataDetails.turn_time_hours || 
        turnTimeProductDataDetails.turn_time_hours === 0) {
        if (turnTimeProductDataDetails.turn_time_hours !== "") {
            if (isChenoa) {
                turn_time_description_ToShow = businessDayDescDisplay(
                    turnTimeProductDataDetails.turn_time_hours
                );
            } else {
                turn_time_description_ToShow = businessDayDescriptionDisplay(
                    turnTimeProductDataDetails.turn_time_hours
                );
            }

        } else {
            turn_time_description_ToShow =
                turnTimeProductDataDetails.turn_time_description;
        }
    } else {
        turn_time_description_ToShow =
            turnTimeProductDataDetails.turn_time_description;
    }

    return turn_time_description_ToShow;
}

// // this fn is different in primejumbo, so put as it is
// const formatCash = (n) => {
//     if (n < 1e3) return n
//     if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + 'K'
//     if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + 'M'
//     if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + 'B'
//     if (n >= 1e12) return +(n / 1e12).toFixed(1) + 'T'
// }

export const pricingTableDescription_PrimeJumbo = ({
    data,
    productTitleTableHeaders,
    pricingTableDescriptionKeysAndValuesData_,
    textDescriptionDetails
}) => {
    if (productTitleTableHeaders[1]?.dataTitle) {
        const thirtyYearData = data?.filter((obj) =>
            obj.hasOwnProperty(productTitleTableHeaders[1]?.dataTitle),
        )

        if (thirtyYearData.length > 0) {
            const thirtyYearData_ =
                thirtyYearData[0][productTitleTableHeaders[1]?.dataTitle]
            if (thirtyYearData_?.fico) {
                pricingTableDescriptionKeysAndValuesData_.fico_thirty_year =
                    thirtyYearData_?.fico
            }
            if (thirtyYearData_?.loanAmount) {
                pricingTableDescriptionKeysAndValuesData_.loanAmount_thirty_year =
                    thirtyYearData_?.loanAmount
            }
            if (thirtyYearData_?.ltv) {
                pricingTableDescriptionKeysAndValuesData_.ltv_thirty_year =
                    thirtyYearData_?.ltv
            }
        }
    }

    //--- 2
    if (productTitleTableHeaders[2]?.dataTitle) {
        const ltvFor = data?.filter((obj) =>
            obj.hasOwnProperty(productTitleTableHeaders[2]?.dataTitle),
        )

        if (ltvFor.length > 0) {
            const ltvFor_ = ltvFor[0][productTitleTableHeaders[2]?.dataTitle]

            if (ltvFor_?.ltv) {
                if (productTitleTableHeaders[2]?.dataTitle === '15 YEAR FIXED') {
                    pricingTableDescriptionKeysAndValuesData_.ltv_fifteen_year =
                        ltvFor_?.ltv
                }
            }
        }
    }
    //---

    let textBelow_PricingTable = ''
    // let otherColumnsDifferentLtvText = ''

    // debugger;
    let ltv_string = ''
    if (
        pricingTableDescriptionKeysAndValuesData_.ltv_thirty_year !==
        pricingTableDescriptionKeysAndValuesData_.ltv_fifteen_year
    ) {
        ltv_string = `${pricingTableDescriptionKeysAndValuesData_.ltv_thirty_year}% LTV (${pricingTableDescriptionKeysAndValuesData_.ltv_fifteen_year}% LTV for 15Year)`
    } else {
        ltv_string = `${pricingTableDescriptionKeysAndValuesData_.ltv_thirty_year}% LTV`
    }


    if (textDescriptionDetails && Object.keys(textDescriptionDetails).length !== 0) {
        textBelow_PricingTable = `${
            amountFormatter.format(textDescriptionDetails?.loanAmount)
            } Loan Amount, ${textDescriptionDetails.loanPurposeKeyword}, 
          ${textDescriptionDetails?.primaryOccupancy}, ${textDescriptionDetails?.propertyUsed
            }, ${textDescriptionDetails?.amortizationTerm}, ${textDescriptionDetails?.fico
            } FICO, ${textDescriptionDetails?.ltv} LTV, ${textDescriptionDetails?.propertyState
            } State`
    } else {
        textBelow_PricingTable = `${
            amountFormatter.format(pricingTableDescriptionKeysAndValuesData_.loanAmount_thirty_year)
        } Loan Amount, Purchase,  Primary Home, Single Family, ${pricingTableDescriptionKeysAndValuesData_.fico_thirty_year
            } FICO, ${ltv_string}, CA State`
    }

    return {
        pricingTableDescriptionKeysAndValuesData_,
        textBelow_PricingTable
    }

}

// Check if array has got 30 Year Data , since its default to be shown

const has30YrData = (tableHeaderData, keyToCompare) => {

    if (!tableHeaderData || tableHeaderData.length === 0) return [false, 0] 
  
    let flagArr = [false, 0]
    tableHeaderData.forEach((product, index) => {
        if (Object.keys(product)[0] === keyToCompare || 
        (
            keyToCompare.indexOf(' YR') !== -1 && 
            (
                /** WHL-42 Prime Jumbo: storedCOnfigData can be there in case of ARM */
                Object.keys(product)[0].indexOf('FIXED') !== -1 ||
                Object.keys(product)[0].indexOf('YR') !== -1
            )
        ) ||
        (
            Object.keys(product)[0].indexOf('YEAR_FIXED') !== -1
        )
        ) {
            flagArr = [true, index]
        }
        
    })
    if(flagArr[0]) return flagArr
    else return [false, 0]
}

export const pricingTableDescription_amortTermColumns = ({
    data,
    productTitleTableHeaders,
    pricingTableDescriptionKeysAndValuesData_,
    textDescriptionDetails,
    programName,
}) => {
    /**
     * WHL-32: TO-DO: Currently this fn works only for default text description in :
     * 1. DSCR
     * 2. Prime Jumbo
     * 3. Foreign National
     */

    let pricingTableDescriptionKeysAndValuesData = {
        ...pricingTableDescriptionKeysAndValuesData_
    }

    const isDscr = programName === 'DSCR'
    const isPrimeJumbo = programName === 'Prime Jumbo'

    const loanTypeNameFromStorage =  localStorage.getItem("loanPurposeCode") ?
            computeLoanTypeName({
                str:  localStorage.getItem("loanPurposeCode"),
                programName
            }) : 'Purchase'

    if (productTitleTableHeaders && productTitleTableHeaders.length > 0
    ) {

        let keyToCompare = '30_YEAR_FIXED'
        if(isPrimeJumbo) keyToCompare = '30 YEAR FIXED'
        // debugger
        if(isPrimeJumbo && localStorage.getItem("amortizationType") === 'ARM') keyToCompare = '30 YR'

        const [flag, productPosition] = has30YrData(data, keyToCompare)

        // if not product , retur blank values
        if (!flag) {
            return {
                pricingTableDescriptionKeysAndValuesData: {...pricingTableDescriptionKeysAndValuesData},
                textBelow_PricingTable: ''
            }
        } else { 
            let obj = data[productPosition][keyToCompare]

            /** WHL-49: 
             * Error had occured in case of foreign national
             * handle undefined obj, and reiterate over array to check if corresp. obj present */
            if(!obj) {
                data.forEach((columnNameObj, index) => {
                    if (Object.keys(columnNameObj)[0] === keyToCompare) {
                        obj = data[index][keyToCompare]
                    }
                })
            }

            const { loanAmount, fico, ltv } = obj

            pricingTableDescriptionKeysAndValuesData = {
                ...pricingTableDescriptionKeysAndValuesData,
                loanAmount,
                fico,
                ltv,
            }

            let defaultOccupancy = 'Investment Property'
            let defaultLoanName = loanTypeNameFromStorage  ? loanTypeNameFromStorage + ',' : ''

            if(programName === foreignNationalProgramName) {
                defaultOccupancy = 'Secondary Home'
            }
            if(programName === fha203kProgramName) {
                defaultOccupancy = 'Primary Home'
                defaultLoanName = 'Purchase Rehab,'
            }
            if(isPrimeJumbo) {
                defaultOccupancy = 'Primary Home'
            }

            let textBelow_PricingTable = `${
                amountFormatter.format(loanAmount)
            } Loan Amount,
            ${defaultLoanName} ${defaultOccupancy}, Single Family, ${fico
                } FICO, ${parseFloat(ltv).toFixed(2)
                }% LTV, CA State${
                    isDscr ? ', Debt Service Coverage Ratio' : ''
                }`;

            if(programName === foreignNationalProgramName) {
                textBelow_PricingTable = `${textBelow_PricingTable}, Full Doc`
            }

            return {
                pricingTableDescriptionKeysAndValuesData,
                textBelow_PricingTable
            }
        }
    }
}

export const pricingTableDescription = (data, productTitleTableHeaders, programName, textDescriptionDetails) => {
    let pricingTableDescriptionKeysAndValuesData = {
        fico_purchase: "",
        loanAmount_purchase: "",
        ltv_purchase: "",
        ltv_cashOut: "",
        ltv_irrrl: "",
        ltv_For_streamline_refinance: "",

        ltv_For_limited_cashout: "",
        fico_A_Plus: "",
        loanAmount_A_Plus: "", 
        ltv_A_Plus: "",
        ltv_A: "",
        ltv_Flex_Plus: "",
        ltv_Flex: "",
    };

    if (programName === 'Prime Jumbo') {

        const keyValueData = pricingTableDescriptionKeysAndValuesData

        const {
            pricingTableDescriptionKeysAndValuesData_,
            textBelow_PricingTable
        } = pricingTableDescription_amortTermColumns({
            data,
            productTitleTableHeaders,
            pricingTableDescriptionKeysAndValuesData_: keyValueData,
            textDescriptionDetails,
            programName,
        })
        // pricingTableDescription_PrimeJumbo({
        //     data,
        //     productTitleTableHeaders,
        //     pricingTableDescriptionKeysAndValuesData_: keyValueData,
        //     textDescriptionDetails
        // })

        const pricingTableDescriptionKeysAndValuesData__ = pricingTableDescriptionKeysAndValuesData_

        return {
            pricingTableDescriptionKeysAndValuesData: pricingTableDescriptionKeysAndValuesData__,
            textBelow_PricingTable
        }
    }

    if(programName === "DSCR" || programName === foreignNationalProgramName ||
    programName === fha203kProgramName 
    ) {

        const keyValueData = pricingTableDescriptionKeysAndValuesData

        const {
            pricingTableDescriptionKeysAndValuesData_,
            textBelow_PricingTable
        } = pricingTableDescription_amortTermColumns({
            data,
            productTitleTableHeaders,
            pricingTableDescriptionKeysAndValuesData_: keyValueData,
            textDescriptionDetails,
            programName,
        })
        return {
            pricingTableDescriptionKeysAndValuesData: pricingTableDescriptionKeysAndValuesData_,
            textBelow_PricingTable
        }
        
    }

    if (productTitleTableHeaders[1]?.dataTitle) {
        const purchaseData = data?.filter((obj) =>
            obj.hasOwnProperty(productTitleTableHeaders[1]?.dataTitle) || 
            (
                programName === "Non QM" &&
                Object.keys(obj)[0].toLowerCase() === productTitleTableHeaders[1]?.dataTitle.toLowerCase()
            )
        );

        if (purchaseData.length > 0) {
            const purchaseData_ =
                purchaseData[0][productTitleTableHeaders[1]?.dataTitle];

            if (programName === "Non QM") {
                if (purchaseData_?.fico) {
                    pricingTableDescriptionKeysAndValuesData.fico_A_Plus =
                        purchaseData_?.fico;
                }
                if (purchaseData_?.loanAmount) {
                    pricingTableDescriptionKeysAndValuesData.loanAmount_A_Plus =
                        purchaseData_?.loanAmount;
                }
                if (purchaseData_?.ltv) {
                    pricingTableDescriptionKeysAndValuesData.ltv_A_Plus =
                        purchaseData_?.ltv;
                }
            } else {
                if (purchaseData_?.fico) {
                    pricingTableDescriptionKeysAndValuesData.fico_purchase =
                        purchaseData_?.fico;
                }
                if (purchaseData_?.loanAmount) {
                    pricingTableDescriptionKeysAndValuesData.loanAmount_purchase =
                        purchaseData_?.loanAmount;
                }
                if (purchaseData_?.ltv) {
                    pricingTableDescriptionKeysAndValuesData.ltv_purchase =
                        purchaseData_?.ltv;
                }
            }
        }
    }

    //--- 2
    if (productTitleTableHeaders[2]?.dataTitle) {
        const ltvFor = data?.filter((obj) => {
            return obj.hasOwnProperty(productTitleTableHeaders[2]?.dataTitle) ||
                (
                    programName === "Non QM" &&
                    (
                        Object.keys(obj).length === 1 &&
                        Object.keys(obj)[0].toLowerCase() === productTitleTableHeaders[2]?.dataTitle.toLowerCase()
                    )
                )
            });

        if (ltvFor.length > 0) {
            const ltvFor_ = ltvFor[0][productTitleTableHeaders[2]?.dataTitle];

            if (ltvFor_?.ltv) {

                if (programName === "Non QM") {
                    if (productTitleTableHeaders[2]?.dataTitle === "A") {
                        pricingTableDescriptionKeysAndValuesData.ltv_A = ltvFor_?.ltv;
                    } else if (productTitleTableHeaders[2]?.dataTitle === "Flex+") {
                        pricingTableDescriptionKeysAndValuesData.ltv_Flex_Plus =
                            ltvFor_?.ltv;
                    } else if (productTitleTableHeaders[2]?.dataTitle === "Flex") {
                        pricingTableDescriptionKeysAndValuesData.ltv_Flex = ltvFor_?.ltv;
                    }
                } else {
                    if (productTitleTableHeaders[2]?.dataTitle === "irrrl") {
                        pricingTableDescriptionKeysAndValuesData.ltv_irrrl = ltvFor_?.ltv;
                    } else if (
                        productTitleTableHeaders[2]?.dataTitle === "streamline_refinance"
                    ) {
                        pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance =
                            ltvFor_?.ltv;
                    } else if (
                        productTitleTableHeaders[2]?.dataTitle === "limited_cashout"
                    ) {
                        pricingTableDescriptionKeysAndValuesData.ltv_For_limited_cashout =
                            ltvFor_?.ltv;
                    }
                }
            }
        }
    }
    //---
    if (productTitleTableHeaders[3]?.dataTitle && programName !== "Non QM") {
        const cashOutData = data?.filter((obj) =>
            obj.hasOwnProperty(productTitleTableHeaders[3]?.dataTitle) || 
            (
                programName === "Non QM" &&
                Object.keys(obj)[0].toLowerCase() === productTitleTableHeaders[3]?.dataTitle.toLowerCase()
            )
        );

        if (cashOutData.length > 0) {
            const cashOutData_ =
                cashOutData[0][productTitleTableHeaders[3]?.dataTitle];

            if (cashOutData_?.ltv) {
                pricingTableDescriptionKeysAndValuesData.ltv_cashOut =
                    cashOutData_?.ltv;
            }
        }
    }

    // setPricingTableDescriptionKeysAndValues(
    //     pricingTableDescriptionKeysAndValuesData
    // );
    //---

    let textBelow_PricingTable = "";
    let otherColumnsDifferentLtvText = "";
    if (programName === "VA") {
        const ltv_irrrl =
            pricingTableDescriptionKeysAndValuesData.ltv_irrrl !==
                pricingTableDescriptionKeysAndValuesData.ltv_purchase
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_irrrl}% for IRRRL`
                : null;

        const ltv_cashOut =
            pricingTableDescriptionKeysAndValuesData.ltv_cashOut !==
                pricingTableDescriptionKeysAndValuesData.ltv_purchase
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_cashOut}% for Cash Out Refinance`
                : null;
        if (
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_irrrl ||
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_cashOut
        ) {
            otherColumnsDifferentLtvText =
                ltv_irrrl && ltv_cashOut
                    ? ` (${ltv_irrrl} and ${ltv_cashOut})`
                    : ltv_irrrl
                        ? ` (${ltv_irrrl})`
                        : ltv_cashOut
                            ? ` (${ltv_cashOut})`
                            : "";
        }
        textBelow_PricingTable = `${amountFormatter.format(pricingTableDescriptionKeysAndValuesData.loanAmount_purchase)} Loan Amount, Primary Home, Single Family, 30 Year Fixed, ${pricingTableDescriptionKeysAndValuesData.fico_purchase
            } FICO, ${pricingTableDescriptionKeysAndValuesData.ltv_purchase
            }% LTV${otherColumnsDifferentLtvText}, CA State`;
    } else if (programName === "FHA") {
        const ltv_For_streamline_refinance =
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
                pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance}% for Streamline Refinance`
                : null;
        const ltv_cashOut =
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
                pricingTableDescriptionKeysAndValuesData.ltv_cashOut
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_cashOut}% for Cash Out Refinance`
                : null;
        if (
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance ||
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_cashOut
        ) {
            otherColumnsDifferentLtvText =
                ltv_For_streamline_refinance && ltv_cashOut
                    ? ` (${ltv_For_streamline_refinance} and ${ltv_cashOut})`
                    : ltv_cashOut
                        ? ` (${ltv_cashOut})`
                        : ltv_For_streamline_refinance
                            ? ` (${ltv_cashOut})`
                            : null;
        }
        textBelow_PricingTable = `${amountFormatter.format(pricingTableDescriptionKeysAndValuesData.loanAmount_purchase)} Loan Amount, Primary Home, Single Family, 30 Year Fixed, ${pricingTableDescriptionKeysAndValuesData.fico_purchase
            } FICO, ${pricingTableDescriptionKeysAndValuesData.ltv_purchase}% LTV${otherColumnsDifferentLtvText ? otherColumnsDifferentLtvText : ""
            }, CA State`;
    } else if (isChenoa) {

        textBelow_PricingTable = `${amountFormatter.format(pricingTableDescriptionKeysAndValuesData.loanAmount_purchase)
            } Loan Amount, Purchase, Primary Home, Single Family, 30 Year Fixed, ${pricingTableDescriptionKeysAndValuesData.fico_purchase
            } FICO, ${pricingTableDescriptionKeysAndValuesData.ltv_purchase}% LTV, CA State`;

    } else if (programName === "USDA") {
        const ltv_For_streamline_refinance =
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
                pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance}% for Streamline Refinance`
                : null;
        if (
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_For_streamline_refinance
        ) {
            otherColumnsDifferentLtvText = ltv_For_streamline_refinance
                ? ` (${ltv_For_streamline_refinance})`
                : null;
        }
        textBelow_PricingTable = `${
            amountFormatter.format(pricingTableDescriptionKeysAndValuesData.loanAmount_purchase)
        } Loan Amount, Primary Home, Single Family, 30 Year Fixed, ${pricingTableDescriptionKeysAndValuesData.fico_purchase
            } FICO, ${pricingTableDescriptionKeysAndValuesData.ltv_purchase}% LTV${otherColumnsDifferentLtvText ? otherColumnsDifferentLtvText : ""
            }, CA State`;
    } else if (programName === "Conventional") {
        const ltv_For_limited_cashout =
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
                pricingTableDescriptionKeysAndValuesData.ltv_For_limited_cashout
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_For_limited_cashout}% for Limited Cash Out`
                : null;
        const ltv_cashOut =
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
                pricingTableDescriptionKeysAndValuesData.ltv_cashOut
                ? `${pricingTableDescriptionKeysAndValuesData.ltv_cashOut}% for Cash Out Refinance`
                : null;
        if (
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_For_limited_cashout ||
            pricingTableDescriptionKeysAndValuesData.ltv_purchase !==
            pricingTableDescriptionKeysAndValuesData.ltv_cashOut
        ) {
            otherColumnsDifferentLtvText =
                ltv_For_limited_cashout && ltv_cashOut
                    ? ` (${ltv_For_limited_cashout} and ${ltv_cashOut})`
                    : ltv_cashOut
                        ? ` (${ltv_cashOut})`
                        : ltv_For_limited_cashout
                            ? `(${ltv_For_limited_cashout})`
                            : "";
        }
        textBelow_PricingTable = `${
            amountFormatter.format(pricingTableDescriptionKeysAndValuesData.loanAmount_purchase)
        } Loan Amount, Primary Home, Single Family, Standard Conforming ,30 Year Fixed, ${pricingTableDescriptionKeysAndValuesData.fico_purchase
            } FICO, ${pricingTableDescriptionKeysAndValuesData.ltv_purchase
            }% LTV${otherColumnsDifferentLtvText}, CA State`;
    } else if (programName === "Non QM") {

        // const ltv_Flex_Plus =
        //     pricingTableDescriptionKeysAndValuesData.ltv_Flex_Plus !==
        //         pricingTableDescriptionKeysAndValuesData.ltv_A_Plus
        //         ? `${pricingTableDescriptionKeysAndValuesData.ltv_Flex_Plus}% for Flex+`
        //         : null;

        // if (
        //     pricingTableDescriptionKeysAndValuesData.ltv_A_Plus !==

        //     pricingTableDescriptionKeysAndValuesData.ltv_Flex_Plus

        // ) {
        //     if (ltv_Flex_Plus) {
        //         otherColumnsDifferentLtvText = ` (${ltv_Flex_Plus})`;

        //     } else {
        //         otherColumnsDifferentLtvText = "";
        //     }
        // }

        const loanTypeNameFromStorage =  localStorage.getItem("loanPurposeCode") ?
            computeLoanTypeName({
                str:  localStorage.getItem("loanPurposeCode"),
                programName
            }) : 'Purchase'
        textBelow_PricingTable = `${
            amountFormatter.format(pricingTableDescriptionKeysAndValuesData.loanAmount_A_Plus)
        } Loan Amount, ${
            loanTypeNameFromStorage
        }, Primary Home, Single Family, 30 Year Fixed, ${pricingTableDescriptionKeysAndValuesData.fico_A_Plus
            } FICO, ${pricingTableDescriptionKeysAndValuesData.ltv_A_Plus
            }% LTV${otherColumnsDifferentLtvText}, CA State, 24-Month Bank Statement `;
    }


    // setTextBelowPricingTable(textBelow_PricingTable);


    return {
        pricingTableDescriptionKeysAndValuesData,
        textBelow_PricingTable
    }
    //---
}

const filterHecmFixedResponse = (res) => {

    // error case
    if (res.length === 0) {
        return [];
    }

    // Remove 0 values
    let aboveZeroValuesArr = res.filter(elementArr => {
        return Math.abs(parseFloat(elementArr[1])) > 0.00
    })

    // remove - sign
    aboveZeroValuesArr.map(elementArr => {
        elementArr[1] = elementArr[1].replace('-', '')
        return elementArr
    })
    return aboveZeroValuesArr
}


export const drawHECMgrid = (response_) => {

    const resp = response_

    /** Get the required two table objects */
    const tableTitle1 = 'MONTHLY HECM CMT ARM (10% LIFETIME CAP) 15-DAY LOCK [REVERSE MORTGAGE]'
    const tableTitle2 = 'MONTHLY HECM CMT ARM (5% LIFETIME CAP) 15-DAY LOCK [REVERSE MORTGAGE]'

    const firstTable = resp.rateGrids[tableTitle1]
    const secondTable = resp.rateGrids[tableTitle2]

    /** Assign column names */
    /**default first column is Margin */
    let columnNames = ['Margin', ...Object.keys(firstTable).filter(item => item.includes('PLU%'))]

    /** Assign RHS col data  */
    let newTable = []
    Object.keys(firstTable).forEach(columnTitle => {
        if (columnNames.includes(columnTitle)) {
            newTable[columnTitle] = [...firstTable[columnTitle]
            .slice(0, 10)]
            .map(item => {
                if(item && isNaN(Number(item))) return item // WHL-105: N/A to be printed as it is in the table
                return parseNumberToFloat(item, 3)
            })

        }
    })

    let newTable2 = []
    Object.keys(secondTable).forEach(columnTitle => {

        if (columnNames.includes(columnTitle)) {
            newTable2[columnTitle] = [...secondTable[columnTitle].slice(0, 10)].map(item => {
                if(item && isNaN(Number(item))) return item // WHL-105: N/A to be printed as it is in the table
                return parseNumberToFloat(item, 3)
            })
        }
    })

    /** for HECM Fixed, add YSP info as well */
    const hecmFixedResData = response_.rateGrids["HECM FIXED (LENDER PAID) [REVERSE MORTGAGE]"]

    const newHecmFixedData = {
        ...hecmFixedResData,
        YSP: response_.YSL ? filterHecmFixedResponse(Object.entries(response_.YSL[0].SUNWST000)) : []
    }


    return {
        tableData1: firstTable,
        tableData2: secondTable,
        gridData1: newTable,
        gridData2: newTable2,
        table1Columns: [...columnNames],
        table2Columns: [...columnNames],
        hecmFixedData: newHecmFixedData ,
        hecmPriceAdjustmentsData: response_.rateGrids["HECM PRICE ADJUSTMENTS [REVERSE MORTGAGE]"],
        maxAllowedFeeValuesData: response_.rateGrids["Maximum Allowable Origination Fee Calculation [REVERSE MORTGAGE]"]
    }

}

export const computeHecmTableCellValue = (resField) => {

    let newString = parseFloat(resField).toFixed(3)
    newString = (newString.charAt(0) === '-' ? newString.substring(1, newString.length) : newString)

    if(resField && isNaN(Number(resField))) newString = resField // WHL-105
    
    // +
    //     `<div class="table-cell-add-on-text">
    //   ${newString.charAt(0) === '-' ? ' Rebate' : ' Cost'}
    // </div>`

    return newString

}

export const redTextField = ({
    FieldName
}) => `<span>${FieldName ? FieldName : 'Field'} <span classname="color-red">Not Provided</span></span>`


export const productTypeOption = [
    { code: 'SC', name: 'Standard Conforming' },
    { code: '281', name: 'RefiNow' },
    { code: '280', name: '7-10 Financed Properties' },
    { code: '900', name: 'HomeReady' },
    { code: 'H', name: 'Refi Possible' },
    { code: 'P', name: 'Home Possible' },
    { code: 'O', name: 'HomeOne' },
    { code: '279', name: 'HomeStyle Renovation' },
    { code: '841', name: 'Student Loan Refinance' },
    { code: '151', name: 'Construction-Permanent' },
    // { code: '282', name: 'Expanded Conforming' },
]

export const customTableHeaderForMargin = (header_) => {
    return header_.replace('15-DAY LOCK', 'REBATE PRICING').replace('30-DAY LOCK', 'REBATE PRICING')
}

export const parseNumberToFloat = (str, decimals) => parseFloat(str).toFixed(decimals)

export const pascalCaseString = (inputString, exceptionArr) => {

    if(!exceptionArr) exceptionArr = []
    const str = inputString
    return str.split(' ')
    .map(item => !exceptionArr.includes(item) ? item.charAt(0).toUpperCase() + item.substr(1, item.length).toLowerCase() : item)
    .join(' ')
}

export const computeLoanTypeName = ({
    str,
    programName
}) => {
    switch(programName){
        case 'Non QM' : 
        case 'non-qmloans' : 
        case 'DSCR' : 
        case 'Foreign National' : {
            switch (str) {
                case "":
                case "PURCHASE":
                    return "Purchase";
                case "FULL DOCS REFI":
                    return "Rate and Term Refinance";
                case "CASH OUT REFI":
                    return "Cash Out Refinance";
                //no default
            }
            // break;
        }
        case 'nonconformingloans' :
        case 'Prime Jumbo' : {
            switch (str) {
                case "":
                case "PURCHASE":
                    return "Purchase";
                case "FULL DOCS REFI":
                    return "No Cash Out Refinance";
                case "CASH OUT REFI":
                    return "Cash Out Refinance";
                //no default
            }
            // break;
        }
        case 'FHA 203K' : {
            switch (str) {
                case "PURCHASE":
                case "PURCHASE REHAB":
                    return 'Purchase Rehab';
                case "REFI REHAB":
                    return 'Refi Rehab';
            }
        }
        case 'Chenoa DPA' : return 'Purchase'
        default: return 'Purchase.'
    }

}



const hecm_ysp = [
    {
        "SUNWST000": {
            "3.9300": "-5.2500",
            "3.9900": "-5.2500",
            "4.0000": "0.0000",
            "4.0600": "-5.2500",
            "4.1800": "-5.2500",
            "4.2500": "0.0000",
            "4.3100": "-5.2500",
            "4.4300": "-5.2500",
            "4.5000": "0.0000",
            "4.5600": "-5.2500",
            "4.6800": "-5.2500",
            "4.7500": "0.0000",
            "4.8100": "0.0000",
            "4.9300": "0.0000",
            "4.9900": "0.0000",
            "5.0600": "0.0000",
            "5.1800": "0.0000"
        }
    }
]

export const primeJumboArmTableHeaders = [
    { "id": "1", "label": "Rate" },
    {
      "id": "2",
      "label": "15 YR ARM",
      "dataTitle": "15 YR ARM",
      "productCode": "SUNNPM276",
      "apiRequestJsonFileName": "va-wholesale-IRRRL-search-scenario",
      "apiRequestJsonFileImportVariableName": "va_wholesale_IRRRL_search_scenario"
    },
    {
      "id": "3",
      "label": "30 YR ARM: 5/6 ARM",
      "dataTitle": "30 YR ARM: 5/6 ARM",
      "paymentDescription": "30 YR ARM 5YR / 6MO : 30 DAY SOFR",
      "productCode": "SUNNPM0276",
      "apiRequestJsonFileName": "va-wholesale-purchase-search-scenario",
      "apiRequestJsonFileImportVariableName": "va_wholesale_purchase_search_scenario"
    },
    {
      "id": "3",
      "label": "30 YR ARM: 7/6 ARM",
      "dataTitle": "30 YR ARM: 7/6 ARM",
      "paymentDescription": "30 YR ARM 7YR / 6MO : 30 DAY SOFR",
      "productCode": "SUNNPM0276",
      "apiRequestJsonFileName": "va-wholesale-purchase-search-scenario",
      "apiRequestJsonFileImportVariableName": "va_wholesale_purchase_search_scenario"
    },
    {
      "id": "3",
      "label": "30 YR ARM: 10/6 ARM",
      "dataTitle": "30 YR ARM: 10/6 ARM",
      "paymentDescription": "30 YR ARM 10YR / 6MO : 30 DAY SOFR",
      "productCode": "SUNNPM0276",
      "apiRequestJsonFileName": "va-wholesale-purchase-search-scenario",
      "apiRequestJsonFileImportVariableName": "va_wholesale_purchase_search_scenario"
    }
    
  ]

export const dscrTableHeaders = [
    { "id": "1", "label": "Rate" },
    {
        "id": "3",
        "label": "NON-QM EZ DSC TIER 1",
        "dataTitle": "NON-QM EZ DSC TIER 1",
        "productCode": "SUNNPM0307",
        "apiRequestJsonFileName": "",
        "apiRequestJsonFileImportVariableName": ""
    },
    {
        "id": "4",
        "label": "NON-QM EZ DSC TIER 2",
        "dataTitle": "NON-QM EZ DSC TIER 2",
        "productCode": "SUNNPM0360",
        "apiRequestJsonFileName": "",
        "apiRequestJsonFileImportVariableName": ""
    }
]

export const videoIdArray = [
    {
        id: 'ir--TLAkm_c'
    },
{
        id: 'E-qdMT-5fBo'
    },
{
        id: 'lvWDw52rkTA'
    },
{
        id: 'wZUDCi8tUMs'
    },
{
        id: 'bl7F-8RItNY'
    },
{
        id: 'eghp8JMGTdI'
    },
{
        id: '8BTtaTTFsM0'
    },
{
        id: '6KyUUlNwvps'
    },
{
        id: 'rhNGC8Cib0M'
    },
{
        id: 'K8dbp6fgflw'
    },
{
        id: 'AN0rt9s6i4A'
    },
{
        id: 'va2LlcRqimc'
    },
{
        id: '9UdEqTUtJjw'
    },
{
        id: 'KhgL881GDxQ'
    },
{
        id: 'XaQdntBdaWg'
    },
{
        id: 'o7yf8t8jges'
    },
{
        id: 'XyNFtypXXyA'
    },
{
        id: 'XCqqieHh6KM'
    },
{
        id: 'Riw_5PpiTmc'
    },
{
        id: 'B-12_vaykgU'
    },
{
        id: '-FV3-HRigNQ'
    },
{
        id: '-jGZgtRQxCw'
    },
{
        id: 'RKgS4knWOeE'
    },
{
        id: 'RjuHhXqG9ns'
    },
{
        id: '7DUj3MN8d9M'
    },
{
        id: 'xD-ca0IipBo'
    },
{
        id: 'U54B4iV8gTE'
    },
{
        id: 'D1-2ksSsao8'
    },
{
        id: 'yL2WdMxs29c'
    },
{
        id: 'kzqoga4_iTQ'
    },
{
        id: 'kzpeak4gp3c'
    },
{
        id: 'rEkyvNYKA7M'
    },
{
        id: '0gvqsEpefJI'
    },
{
        id: 'phFI4gZGV5E'
    },
{
        id: 'ZEUS9FuF1qg'
    },
{
        id: 'Oh_-yOUm7qA'
    },
    {
        id: ''
    },
{
        id: ''
    },
]

// export const generateYtThumbnail = (idPassed) => `${imagePathS3}/videoThumbnails/${idPassed}.jpg`
export const generateYtThumbnail = (idPassed) => `${imagePath1}/videoThumbnails/${idPassed}.webp`

export const generateYtVideoLink = (idPassed) => `https://www.youtube.com/watch?v=${idPassed}&authuser=0`

export const dragElement = (elmnt, holderEle) => { // (myDIv, myDiveader is holding element for this for this)
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    if (document.getElementById(elmnt.id + "header")) {
        /* if present, the header is where you move the DIV from:*/
        document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
    } else if (holderEle && holderEle.length > 0) {
        /* if present, the header is where you move the DIV from:*/
        holderEle[0].onmousedown = dragMouseDown;
    } else {
        /* otherwise, move the DIV from anywhere inside the DIV:*/
        elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }
}

export const removeExtraStringAtEnd = (baseStr, toBeRemoved) => {
    let newStr = baseStr.substring(0, baseStr.indexOf(toBeRemoved) !== -1 ? baseStr.indexOf(toBeRemoved) : baseStr.length ) //.substring(0, baseStr.indexOf(toBeRemoved) )
    return newStr
}

export const isRelatedToCondo = (string_) => {
    return string_ === 'CONDO' ||
    string_ === 'NON WARRANT' ||
    string_ === 'CONDO-HOTEL' ||
    string_ === 'SITE CONDO' 
}

export const isRelatedToManuftd = (string_) => {
    return string_ === 'MANUFACTURED' ||
    string_ === 'MANUFACTURED SW' ||
    string_ === 'MANUFACTURED PD' ||
    string_ === 'MANUFACTURED PS' ||
    string_ === 'MANUFACTURED CO' ||
    string_ === 'MANUFACTURED CS' ||
    string_ === 'MANUFACTURED MH'
}

export const condoPropertyMappings = {
    "CONDO": "Condo(Warrantable Condo)",
    "NON WARRANT": "Non-Warrantable Condo",
    "CONDO-HOTEL": "Condotel",
    "SITE CONDO": "Site Condo / Detached Condo",
}

export const manufactrdPropertyMappings = {
    "MANUFACTURED": "Manufactured Housing (Multi Wide)",
    "MANUFACTURED SW": "Manufactured Housing (Single Wide)",
    "MANUFACTURED PD": "Manufactured Home/PUD (Multi Wide)",
    "MANUFACTURED PS": "Manufactured Home/PUD (Single Wide)",
    "MANUFACTURED CO": "Manufactured Condo (Multi Wide)",
    "MANUFACTURED CS": "Manufactured Condo (Single Wide)",
    "MANUFACTURED MH": "Manufactured Home: MH Advantage",
}

export const brokerFormOffline = 'https://prod-cdn.swmc.com/swmc-common/docs/SWMC_Broker_Application_Package_9.7.pdf'

export const scroller = (refObj) => {
    if(refObj.query) {
        const formRef = document.querySelectorAll(refObj.query)
        if(formRef && formRef.length === 1) {
            formRef[0].scrollIntoView()
        }
    }
    if(refObj.id) {
        const formRef = document.getElementById(refObj.id)
        if(formRef) {
            formRef.scrollIntoView()
        }
    }
}

export const openInNewTab = (link) => window.open(link, '_blank')

export const getLoanTypeTitle = ({
    loanNamePassed,
    pageNamePassed
}) => {

    switch (loanNamePassed) {
        case "Purchase": 
        case "PURCHASE": return 'Purchase' 
        case "FULL DOCS REFI": {
            switch (pageNamePassed) {
                case 'FHA':
                case 'USDA':
                    return 'Streamline Refinance'
                case 'VA': return 'IRRRL'
                case 'Conventional': return 'Limited Cash Out'
                case 'Non QM':
                case 'DSCR': return 'Rate and Term Refinance'
                case 'Prime Jumbo': return 'No Cash Out Refinance'
                
                default: return ''
            }
        }
        case "CASH OUT REFI": {
            return "Cash Out Refinance";
        }
        //no default
    }
}
export const convertArmValueBackToYrMo = inputStr => inputStr 
    .replace(' ARM', '')
    .replace('/', 'YR/')
    .concat('M')

export const pricingErrorMessage = `<div classname="pricing-error-message-wrapper">
    <span classname="white-space-nowrap-limited">Unable to find matching product. </span>
    <span classname="white-space-nowrap-limited">
        Please call pricing desk at
            <span classname="white-space-nowrap">
                <a href="tel:+18445625337" style="color: inherit; text-decoration: underline">(844) 562-5337</a>
            </span>
        for customized product exception.
    </span>
</div>`

export const amortTermFixedJsxArr = [
    {
        id: 'amorTerm1',
        name: 'amorTerm1',
        value: '40 year fixed',
        'aria-label': '40 year fixed',
        label: '40 Year Fixed',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/40_year_fixed.svg',
        imgAlt: '40 year fixed image',
        titleText: '40 Year Fixed'
    },
    {
        id: 'amorTerm2',
        name: 'amorTerm2',
        value: '30 year fixed',
        'aria-label': '30 year fixed',
        label: '30 Year Fixed',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/30_year_fixed.svg',
        imgAlt: '30 year fixed image',
        titleText: '30 Year Fixed'
    },
    {
        id: 'amorTerm3',
        name: 'amorTerm3',
        value: '15 year fixed',
        'aria-label': '15 year fixed',
        label: '15 Year Fixed',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/15_year_fixed.svg',
        imgAlt: '15 year fixed image',
        titleText: '15 Year Fixed'
    },
]

export const amortTermArmV1JsxArr = [
    {
        id: 'amorTerm1',
        name: 'amorTerm1',
        value: '5/6 ARM',
        'aria-label': '5/6 ARM',
        label: '5/6 ARM',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/40_year_arm_5by6.svg',
        imgAlt: '5/6 ARM image',
        titleText: '5/6 ARM'
    },
    {
        id: 'amorTerm2',
        name: 'amorTerm2',
        value: '7/6 ARM',
        'aria-label': '7/6 ARM',
        label: '7/6 ARM',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/40_year_arm_7by6.svg',
        imgAlt: '7/6 ARM image',
        titleText: '7/6 ARM'
    },
]


export const amortTermArmV2JsxArr = [
    {
        id: 'amorTerm1',
        name: 'amorTerm1',
        value: '40 year arm 5/6',
        'aria-label': '40 year arm 5/6',
        label: '40 YEAR ARM: 5YR/6MO',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/40_year_arm_5by6.svg',
        imgAlt: '40 year arm 5/6 image',
        titleText: '40 YEAR ARM: 5YR/6MO'
    },
    {
        id: 'amorTerm2',
        name: 'amorTerm2',
        value: '40 year arm 7/6',
        'aria-label': '40 year arm 7/6',
        label: '40 YEAR ARM: 7YR/6MO',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/40_year_arm_7by6.svg',
        imgAlt: '40 year arm 7/6 image',
        titleText: '40 YEAR ARM: 7YR/6MO'
    },
    {
        id: 'amorTerm3',
        name: 'amorTerm3',
        value: '30 year arm 5/6',
        'aria-label': '30 year arm 5/6',
        label: '30 YEAR ARM: 5YR/6MO',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/30_year_arm_5by6.svg',
        imgAlt: '30 year arm 5/6 image',
        titleText: '30 YEAR ARM: 5YR/6MO'
    },
    {
        id: 'amorTerm4',
        name: 'amorTerm4',
        value: '30 year arm 7/6',
        'aria-label': '30 year arm 7/6',
        label: '30 YEAR ARM: 7YR/6MO',
        imgRelativePath: '/questionnaireIcons/amortizationTerm/30_year_arm_7by6.svg',
        imgAlt: '30 year arm 7/6 image',
        titleText: '30 YEAR ARM: 7YR/6MO'
    },
]

/** WHL-60: Variable to dyanmically assign bootstrap columns  */
export const amorTermIconsColBStrapNumbers = amortTermDropdownArr => amortTermDropdownArr.length === 2 ?
    [4, 4, 6, 6] : amortTermDropdownArr.length === 3 ?
    [4, 4, 4, 6] : [3, 4, 4, 6]
export const computePropertyUsedString = (propertyUsePassed, penaltyTermPassed) => {
    /** WHL-49 */
    /** Format expected:
     * 5 Year Prepayment Penalty
        4 Year Prepayment Penalty
        3 Year Prepayment Penalty
        2 Year Prepayment Penalty
        1 Year Prepayment Penalty
        No Prepayment Penalty
     */
    if ((
        propertyUsePassed && (
            parseInt(propertyUsePassed) === 2
        )
    ) &&
        penaltyTermPassed && (
            parseInt(penaltyTermPassed) ||
            (parseInt(penaltyTermPassed) === 0)
        )) {

        let returnStr = `${parseInt(penaltyTermPassed) / 12} Year Prepayment Penalty`
        if (parseInt(penaltyTermPassed) === 0) returnStr = `No Prepayment Penalty`
        return returnStr
    } else return ''
}


export const convertyrMoValueToArm = inputStr => inputStr 
    .split(' ')[0]
    .replace('YR', '')
    .replace('Mo', '')
    .replace('M', '')
    .concat(' ARM')


export const addResizeListener = (callback) => {
    window.addEventListener('resize', callback)
} 
export const removeResizeListener = (callback) => {
    window.removeEventListener('resize', callback)
} 

export const convProductTypesArr = [
    {
        id: 'convProduct1',
        name: 'convProduct1',
        value: 'SC',
        'aria-label': 'Standard Conforming',
        label: 'Standard Conforming',
        imgRelativePath: '/questionnaireIcons/productTypes/Standard-Conforming.svg',
        imgAlt: 'Standard Conforming image',
        titleText: 'Standard Conforming'
    },
    {
        id: 'convProduct2',
        name: 'convProduct2',
        value: '281',
        'aria-label': 'RefiNow',
        label: 'RefiNow',
        imgRelativePath: '/questionnaireIcons/productTypes/Refi-Now.svg',
        imgAlt: 'RefiNow image',
        titleText: 'RefiNow'
    },
    {
        id: 'convProduct3',
        name: 'convProduct3',
        value: '280',
        'aria-label': '7-10 Financed Properties',
        label: '7-10 Financed Properties',
        imgRelativePath: '/questionnaireIcons/productTypes/7-10-Financed-Properties.svg',
        imgAlt: '7-10 Financed Properties image',
        titleText: '7-10 Financed Properties'
    },
    {
        id: 'convProduct4',
        name: 'convProduct4',
        value: '900',
        'aria-label': 'HomeReady',
        label: 'HomeReady',
        imgRelativePath: '/questionnaireIcons/productTypes/HomeReady.svg',
        imgAlt: 'HomeReady image',
        titleText: 'HomeReady'
    },
    {
        id: 'convProduct5',
        name: 'convProduct5',
        value: 'H',
        'aria-label': 'Refi Possible',
        label: 'Refi Possible',
        imgRelativePath: '/questionnaireIcons/productTypes/Refi-Possible.svg',
        imgAlt: 'Refi Possible image',
        titleText: 'Refi Possible'
    },
    {
        id: 'convProduct6',
        name: 'convProduct6',
        value: 'P',
        'aria-label': 'Home Possible',
        label: 'Home Possible',
        imgRelativePath: '/questionnaireIcons/productTypes/Home-Possible.svg',
        imgAlt: 'Home Possible image',
        titleText: 'Home Possible'
    },
    {
        id: 'convProduct7',
        name: 'convProduct7',
        value: 'O',
        'aria-label': 'HomeOne',
        label: 'HomeOne',
        imgRelativePath: '/questionnaireIcons/productTypes/HomeOne.svg',
        imgAlt: 'HomeOne image',
        titleText: 'HomeOne'
    },
    {
        id: 'convProduct8',
        name: 'convProduct8',
        value: '279',
        'aria-label': 'HomeStyle Renovation',
        label: 'HomeStyle Renovation',
        imgRelativePath: '/questionnaireIcons/productTypes/HomeStyle-Renovation.svg',
        imgAlt: 'HomeStyle Renovation image',
        titleText: 'HomeStyle Renovation'
    },
    {
        id: 'convProduct9',
        name: 'convProduct9',
        value: '841',
        'aria-label': 'Student Loan Refinance',
        label: 'Student Loan Refinance',
        imgRelativePath: '/questionnaireIcons/productTypes/Student-Loan-Refinance.svg',
        imgAlt: 'Student Loan Refinance image',
        titleText: 'Student Loan Refinance'
    },
    {
        id: 'convProduct10',
        name: 'convProduct10',
        value: '151',
        'aria-label': 'Construction-Permanent',
        label: 'Construction-Permanent',
        imgRelativePath: '/questionnaireIcons/productTypes/Construction-Permanent.svg',
        imgAlt: 'Construction-Permanent image',
        titleText: 'Construction-Permanent'
    },
]
export const isJumbo = process.env.REACT_APP_URL === 'nonconformingloans'
export const isJumboWithArm = isJumbo && (localStorage.getItem("amortizationType") === 'ARM')

export const WaterMarkNormal = ({
    className,
    truthyCondtnToRender
}) => {
    return <>
        {truthyCondtnToRender && <div
            className={`newline ${className}`}
        >
            <span style={{ whiteSpace: "nowrap" }}>For NMLS Licensees</span>
            <br />
            <span>Only</span>
        </div>}
        </>
}
   
export const WaterMarkOneLiner = ({
    className,
    truthyCondtnToRender
}) => {
    return <>
        {truthyCondtnToRender && <div
            className={`newline ${className}`}
        >
            <span style={{ whiteSpace: "nowrap" }}>For NMLS Licensees Only</span>
        </div>}
        </>
}

export const isFha = process.env.REACT_APP_URL === 'fhaloans'

export const amountFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

export const ifNoMatchingProduct = (allowedProductArray, response) => {
    let productsAbsent = true
    allowedProductArray.forEach(allowedCode => {
        if (response.data.filter(obj => obj.productCode === allowedCode)[0]) {
            productsAbsent = false
        }
    })
    return productsAbsent
}

/** WHL-98: value field made simiar to productDescription for api response */
export const chenoaDpaDropdown = [
    {
        title: 'FHA 1ˢᵗ REPAYABLE 3.5%',
        value: 'REPAYABLE 3.5%',
    },
    {
        title: 'FHA 1ˢᵗ REPAYABLE 5.0%',
        value: 'REPAYABLE 5%',
    },
    {
        title: 'FHA 1ˢᵗ FORGIVABLE 3.5%',
        value: 'FORGIVABLE 3.5%',
    },
    {
        title: 'FHA 1ˢᵗ FORGIVABLE 5.0%',
        value: 'FORGIVABLE 5%',
    },
]

export const chenoaDpaProductsJsxArr = [
    {
        id: 'dpaProduct1',
        name: 'dpaProduct1',
        value: 'REPAYABLE 3.5%',
        'aria-label': 'FHA 1ˢᵗ Repayable 3.5%',
        label: 'Repayable 3.5%',
        imgRelativePath: '/questionnaireIcons/DpaProduct/FHA-1st-repayable-3.5.svg',
        imgAlt: 'FHA 1ˢᵗ Repayable 3.5% image',
        titleText: 'FHA 1ˢᵗ Repayable 3.5%'
    },
    {
        id: 'dpaProduct2',
        name: 'dpaProduct2',
        value: 'REPAYABLE 5%',
        'aria-label': 'FHA 1ˢᵗ Repayable 5.0%',
        label: 'Repayable 5.0%',
        imgRelativePath: '/questionnaireIcons/DpaProduct/FHA-1st-repayable-5.0.svg',
        imgAlt: 'FHA 1ˢᵗ Repayable 5.0% image',
        titleText: 'FHA 1ˢᵗ Repayable 5.0%'
    },
    {
        id: 'dpaProduct3',
        name: 'dpaProduct3',
        value: 'FORGIVABLE 3.5%',
        'aria-label': 'FHA 1ˢᵗ Forgivable 3.5%',
        label: 'Forgivable 3.5%',
        imgRelativePath: '/questionnaireIcons/DpaProduct/FHA-1st-forgivable-3.5.svg',
        imgAlt: 'FHA 1ˢᵗ Forgivable 3.5% image',
        titleText: 'FHA 1ˢᵗ Forgivable 3.5%'
    },
    {
        id: 'dpaProduct4',
        name: 'dpaProduct4',
        value: 'FORGIVABLE 5%',
        'aria-label': 'FHA 1ˢᵗ Forgivable 5.0%',
        label: 'Forgivable 5.0%',
        imgRelativePath: '/questionnaireIcons/DpaProduct/FHA-1st-forgivable-5.0.svg',
        imgAlt: 'FHA 1ˢᵗ Forgivable 5.0% image',
        titleText: 'FHA 1ˢᵗ Forgivable 5.0%'
    },
]

export const allowedChenoaProductCodes = [
    "SUNGOV0292",
    "SUNGOV0293",
    "SUNGOV0294",
    "SUNGOV0295",
    "SUNGOV0296",
    "SUNGOV0297",
    "SUNGOV0298",
  ]

export const chenoaHighBalanceProducts = [
    'SUNGOV0294',
    'SUNGOV0295',
    'SUNGOV0297',
]

export const computePricingIndices = (arr) => {
    let pricingSliceIndices = [0, 9]

    if(isChenoa) pricingSliceIndices = [arr.length-6, arr.length]

    return pricingSliceIndices
}

export const contactUsTitleLine =  (
     isJumbo || isChenoa || isDscrEnv
) ?  'Mortgage Brokers' : 'Mortgage Brokers and Correspondents'
